import { initialiseComponents } from "../../core";
import Component from "../component.abstract";
import { hw } from "../helpers/paths";
import AlertesHome from "./alertes-home";


export default class AlertesListe extends Component {
  constructor(private props: unknown, element: HTMLElement) {
    super(props, element);
  }

  mounted(): void {
    this.injectTemplate();
    
    PubSub.subscribe("alertes-home.loaded", (msg:string, instance: AlertesHome) => {
      this.populate(instance);
    });
  }
  populate(alerte: AlertesHome): void {
    if(alerte.data) {
      const ul = this.element.querySelector("ul");
      ul.setAttribute("data-sheet", "");
      ul.classList.add("flat");

      // Add GA events
      if (alerte.data.trackingsClick && alerte.data.trackingsClick.length) {
        const submitButton = this.element.querySelector(".asSubmit");
        submitButton.setAttribute(
          "data-track",
          JSON.stringify(alerte.data.trackingsClick[0])
        );
      }
      if (alerte.data.trackingsLoad && alerte.data.trackingsLoad.length) {
        const eventanalytics = alerte.data.trackingsLoad[0];
        eventanalytics.trigger = "init";
        ul.setAttribute("data-track", JSON.stringify(eventanalytics));
      }
      // Build results list
      const items = alerte.data.items;
      if (!alerte.data.emailValidated) {
        this.element.classList.add("valid-mail");
        this.element.querySelector("div").style.display = "flex";
      }
      const svgns = "http://www.w3.org/2000/svg";
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const li = document.createElement("li");
        li.setAttribute("data-component", "");
        li.setAttribute("data-alerte-home-item", "");

        const svg = document.createElementNS(svgns, "svg");
        svg.setAttribute(
          "data-load-url",
          hw.getBaseRessourcesUrl() + "/img/svg/clochenotif.svg"
        );
        li.appendChild(svg);
        if (item.isActive) {
          li.setAttribute("class", "active");
          if (item.newOffers) {
            const spanNew = document.createElement("span");
            spanNew.className = "new";
            li.appendChild(spanNew);
          }
        }
        if (i != items.length - 1) {
          li.classList.add("hseparator");
        }

        const span = document.createElement("span");
        span.className = "name";
        span.innerText = item.name;
        li.appendChild(span);

        const link = document.createElement("a");
        if (alerte.data.emailValidated) {
          link.setAttribute("href", item.url);
          link.setAttribute("id", "offre-" + item.id);
          if (item.trackingsClick && item.trackingsClick.length) {
            link.setAttribute(
              "data-track",
              JSON.stringify(item.trackingsClick[0])
            );
          }
        }
        link.innerText = "Voir les offres";
        li.appendChild(link);

        ul.appendChild(li);
      }
      const lazyElement = document.querySelector("[data-alerte-home]");
      if (lazyElement.className.indexOf("global-lazy-loading") >= 0) {
        // Wait for the other lazy components before displaying the results
        lazyElement.addEventListener("display", () => {
          this.displayResults();
        });
        lazyElement.dispatchEvent(new CustomEvent("ready"));
      } else {
        // Just display the results
        this.displayResults();
      }

       initialiseComponents();
    }
   
  }
  displayResults(): void {
    document
      .querySelector("div[data-alerte-home]>div.lazy")
      .classList.add("hide");
    document
      .querySelector("div[data-alerte-home]>div.hide:not(.lazy)")
      .classList.remove("hide");
    document
      .querySelector("section.alertes .header.lazy-loading")
      .classList.remove("lazy-loading");
  }
}
